import { Link } from 'react-router';

import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';

import ProfileSection from './ProfileSection';

export default function ProfileMyTeamUpgradePanel() {
  return (
    <div className="overview max-w-(--breakpoint-md) mx-auto">
      <div className="mt-8">
        <ProfileSection
          title="My Team"
          contentClassName="dark:bg-gray-90 flex min-h-[280px] flex-col items-center justify-center gap-6 px-6 py-12 text-center"
        >
          <Text as="p" variant="studio/body/sm" className="text-primary max-w-md">
            Upgrade to Team Pro to invite teammates, assign seats, and manage
            your workspace in one place
          </Text>
          <Link
            to="/pricing/team-plans"
            className="inline-flex"
            style={{ textDecoration: 'none' }}
          >
            <Button variant="primary" size="lg">
              Upgrade to Team Pro
            </Button>
          </Link>
        </ProfileSection>
      </div>
    </div>
  );
}
